export default "__VITE_ASSET__Djx1qyQo__"